'use client';

import React from 'react';
import AppLogo from './AppLogo';

interface ClientLogoProps {
  src?: string | null;
  alt?: string;
  size?: number;
  className?: string;
  fallbackClassName?: string;
}

export default function ClientLogo({
  src,
  alt = 'Client logo',
  size = 40,
  className = '',
  fallbackClassName = '',
}: ClientLogoProps) {
  if (!src) {
    return <AppLogo data-component-id="src/components/ui/ClientLogo.tsx:22:11" data-component-path="src/components/ui/ClientLogo.tsx" data-component-line="22" data-component-end-line="22" data-component-file="ClientLogo.tsx" data-component-name="AppLogo" data-component-content="%7B%22elementName%22%3A%22AppLogo%22%2C%22className%22%3A%22%5Bvar%3AfallbackClassName%5D%22%7D" size={size} className={fallbackClassName} />;
  }

  return (
    <div data-component-id="src/components/ui/ClientLogo.tsx:26:4" data-component-path="src/components/ui/ClientLogo.tsx" data-component-line="26" data-component-end-line="31" data-component-file="ClientLogo.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
      className={`flex items-center justify-center overflow-hidden rounded-lg bg-white border border-border ${className}`}
      style={{ width: size, height: size }}
    >
      <img data-component-id="src/components/ui/ClientLogo.tsx:30:6" data-component-path="src/components/ui/ClientLogo.tsx" data-component-line="30" data-component-end-line="30" data-component-file="ClientLogo.tsx" data-component-name="img" data-component-content="%7B%22elementName%22%3A%22img%22%2C%22src%22%3A%22%5Bvar%3Asrc%5D%22%2C%22alt%22%3A%22%5Bvar%3Aalt%5D%22%2C%22className%22%3A%22max-h-full%20max-w-full%20object-contain%20p-1%22%7D" src={src} alt={alt} className="max-h-full max-w-full object-contain p-1" />
    </div>
  );
}
